import i18nFactory, { i18nRaw as i18nRawFactory } from '@yandex-int/i18n';
import * as React from 'react';

import { OutdoorVideoFormat, RecommendationCharacter, RecommendationType } from '../../../typings/recommendations';
import { Shape2Icon } from '../../Shape2/Shape2';
import { RecommendationCard, RecommendationCardView } from '../RecommendationCard';

import * as keyset from './AddAppropriatePlacementRecommendationCard.i18n';

const i18n = i18nFactory(keyset);
const i18nRaw = i18nRawFactory(keyset);

export interface AddAppropriatePlacementRecommendationCardProps {
    character: RecommendationCharacter;
    videoFormats?: Array<OutdoorVideoFormat>;
    view: RecommendationCardView;
    onClose?: () => void;
    title?: string;
    titleHint?: string;
    type: RecommendationType;
}

export const AddAppropriatePlacementRecommendationCard = React.memo(
    (props: AddAppropriatePlacementRecommendationCardProps): JSX.Element | null => {
        const { view, character, videoFormats, title, titleHint, type } = props;

        if (!videoFormats || !videoFormats.length) {
            return null;
        }

        const titleRecommendation = title || getTitle(view);
        const titleHintRecommendation = titleHint || getTitleHint(view);

        return (
            <RecommendationCard
                type={type}
                view={view}
                icon={Shape2Icon.lamp}
                character={character}
                title={titleRecommendation}
                titleHint={titleHintRecommendation}
                isInProgress={false}
            >
                {i18nRaw('add-placements', {
                    formats: <b key={1}>{getFormats(videoFormats.slice(0, 20))}</b>,
                    count: videoFormats.length
                })}
            </RecommendationCard>
        );
    }
);

const getTitle = (view: RecommendationCardView): string | undefined => {
    switch (view) {
        case RecommendationCardView.recommendationsPopup:
            return i18n('title');

        default:
            return;
    }
};

const getTitleHint = (view: RecommendationCardView): string | undefined => {
    switch (view) {
        case RecommendationCardView.recommendationsPopup:
            return i18n('title-hint');

        default:
            return;
    }
};

const getFormats = (videoFormats: Array<OutdoorVideoFormat>) => {
    return videoFormats
        .map(formats => {
            if (!formats) {
                return;
            }

            return i18n('video-format', {
                width: formats.width,
                height: formats.height,
                duration: formats.duration
            });
        })
        .join(', ');
};
